import cx from 'classnames';
import { CheckIcon, CrossIcon } from '@wkda/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Select(_ref) {
  let {
    className,
    options,
    placeholderOption,
    value,
    isValid,
    showVisualFeedback = false,
    mktSelector,
    qaSelector,
    ...selectProps
  } = _ref;
  const status = typeof isValid === 'undefined' ? 'not-validated' : isValid === true ? 'valid' : 'invalid';
  const showPlaceholder = placeholderOption && !value;
  return /*#__PURE__*/_jsxs("div", {
    className: "custom-select__container icon-select__container",
    children: [/*#__PURE__*/_jsxs("select", {
      ...selectProps,
      className: cx('custom-select', className, {
        'is-invalid': status === 'invalid'
      }),
      value: value,
      "data-mkt-selector": mktSelector,
      "data-qa-selector": qaSelector || mktSelector,
      "data-qa-selector-value": value,
      children: [placeholderOption && /*#__PURE__*/_jsx("option", {
        value: '',
        disabled: true,
        children: placeholderOption
      }), Array.isArray(options) ? options.map(_ref2 => {
        let {
          value,
          label
        } = _ref2;
        const usableValue = typeof value === 'boolean' ? String(value) : value;
        return /*#__PURE__*/_jsx("option", {
          value: usableValue,
          "data-qa-selector-value": value,
          children: label
        }, usableValue);
      }) : Object.entries(options).map(_ref3 => {
        let [key, itemOptions] = _ref3;
        return /*#__PURE__*/_jsx("optgroup", {
          label: key,
          children: itemOptions.map(_ref4 => {
            let {
              value,
              label
            } = _ref4;
            const usableValue = typeof value === 'boolean' ? String(value) : value;
            return /*#__PURE__*/_jsx("option", {
              value: usableValue,
              children: label
            }, usableValue);
          })
        }, key);
      })]
    }), showPlaceholder ? /*#__PURE__*/_jsx("div", {
      className: "custom-select__placeholder",
      "aria-hidden": true,
      children: placeholderOption
    }) : null, status === 'valid' && showVisualFeedback ? /*#__PURE__*/_jsx(CheckIcon, {
      className: "icon-select__icon text-success"
    }) : null, status === 'invalid' && showVisualFeedback ? /*#__PURE__*/_jsx(CrossIcon, {
      className: "icon-select__icon icon-select__icon-cross text-danger"
    }) : null]
  });
}